import { i18nMark } from 'lingui-react';

const formattedMessages = {
  selectItem: i18nMark('Select Item...'),
  unit: i18nMark('Unit'),
  whichAsset: i18nMark('Which asset?'),
};

export default formattedMessages;



// WEBPACK FOOTER //
// ./compositions/AssetSelectionStep/messages.js